import { createSlice } from "@reduxjs/toolkit";
import {
    initApproval5mcutObj,
    locationTraffic5mcutObj,
    locationConflictMarketCutObj,
    approval5mcutLocationBase,
    initCoverObj,
} from "../data/type";

//Sliceの作成
export const approval5mcutSlice = createSlice({
    name: "approval5mcut",
    //初期State(Typeからインポート)
    initialState: {
        approvalStatus: initApproval5mcutObj,
        parent5mcut: locationTraffic5mcutObj,
        parentMarketCut: locationConflictMarketCutObj,
        child5mcut: locationTraffic5mcutObj,
        childMarketCut: locationConflictMarketCutObj,
        childPlanAreaId: "",
        hasChild: false,
        parentLocationBase: approval5mcutLocationBase,
        childLocationBase: approval5mcutLocationBase,
        parentLocationCover: initCoverObj,
        childLocationCover: initCoverObj,
    },
    //toolKitを利用した値変更処理
    reducers: {
        setApprovalStatus: (state, action) => {
            state.approvalStatus = action.payload;
        },
        setParent5mcut: (state, action) => {
            state.parent5mcut = action.payload;
        },
        setParentMarketCut: (state, action) => {
            state.parentMarketCut = action.payload;
        },
        setChild5mcut: (state, action) => {
            state.child5mcut = action.payload;
        },
        setChildMarketCut: (state, action) => {
            state.childMarketCut = action.payload;
        },
        setHasChild: (state, action) => {
            state.hasChild = action.payload;
        },
        setParentLocationBase: (state, action) => {
            state.parentLocationBase = action.payload;
        },
        setChildLocationBase: (state, action) => {
            state.childLocationBase = action.payload;
        },
        setParentLocationCover: (state, action) => {
            state.parentLocationCover = action.payload;
        },
        setChildLocationCover: (state, action) => {
            state.childLocationCover = action.payload;
        },
    },
});

export const {
    setApprovalStatus,
    setParent5mcut,
    setParentMarketCut,
    setChild5mcut,
    setChildMarketCut,
    setHasChild,
    setParentLocationBase,
    setChildLocationBase,
    setParentLocationCover,
    setChildLocationCover,
} = approval5mcutSlice.actions;
export default approval5mcutSlice.reducer;
